<template>
  <div>
    <div class="ticket_info_user_title ticket_icon">
      <div class="way_title_left">
        <img :src="staticAssets.ImgObj.user_icon" alt />
        <span>{{TLang('取票人','my')}}</span>
      </div>
    </div>
    <div class="ticket_info_user_table">
      <div class="user_ticket_info">
        <el-form
          :model="cardForm_ticket"
          :rules="cardRules"
          ref="cardForm_ticket"
        >
          <!-- 国际英文版 -->
          <el-form-item
            v-if="!CheckCN()"
            class="el-form-item-three"
            label="Name"
            :label-width="formLabelWidth"
            prop="consigneeName"
          >
            <el-input
              v-model="cardForm_ticket.consigneeName"
              autocomplete="off"
              placeholder="Pls input name of person taking ticket"
            ></el-input>
          </el-form-item>
          <!-- 国际中文版 -->
          <el-form-item
            v-if="CheckCN()"
            class="el_first_item"
            label="姓名"
            :label-width="formLabelWidth"
            prop="consigneeName"
          >
            <el-input
              v-model="cardForm_ticket.consigneeName"
              autocomplete="off"
              placeholder="请输入取票人姓名"
            ></el-input>
          </el-form-item>
          <!-- 国际英文版 -->
          <el-form-item
            class="el-form-item-three"
            label="ID Card"
            :label-width="formLabelWidth"
            prop="ownerIdCardNo"
            v-if="real_type != 2 && real_type != 0 && !CheckCN()"
          >
            <el-input
              v-model="cardForm_ticket.ownerIdCardNo"
              autocomplete="off"
              placeholder="Pls input I'd card no. of 18digits"
              @input="formatCardNo"
            ></el-input>
            <!-- <el-input
              v-model="cardForm_ticket.ownerIdCardNo"
              autocomplete="off"
              placeholder="请输入18位身份证号码"
              @input="
                cardForm_ticket.ownerIdCardNo = cardForm_ticket.ownerIdCardNo
                  .replace(/[^0-9A-z]/g, '')
                  .toUpperCase()
              "
            ></el-input> -->
          </el-form-item>
          <!-- 国际中文版 -->
          <el-form-item
            label="身份证"
            :label-width="formLabelWidth"
            prop="ownerIdCardNo"
            v-if="real_type != 2 && real_type != 0 && CheckCN()"
          >
            <el-input
              v-model="cardForm_ticket.ownerIdCardNo"
              autocomplete="off"
              placeholder="请输入18位身份证号码"
              @input="formatCardNo"
            ></el-input>
            <!-- <el-input
              v-model="cardForm_ticket.ownerIdCardNo"
              autocomplete="off"
              placeholder="请输入18位身份证号码"
              @input="
                cardForm_ticket.ownerIdCardNo = cardForm_ticket.ownerIdCardNo
                  .replace(/[^0-9A-z]/g, '')
                  .toUpperCase()
              "
            ></el-input> -->
          </el-form-item>
          <!-- 国际英文版 -->
          <el-form-item
            v-if="!CheckCN()"
            label="Phone number"
            
            prop="consigneePhone"
            class="el-form-item-One"
          >
            <el-input
              v-model="cardForm_ticket.consigneePhone"
              autocomplete="off"
              placeholder="Pls input phone no. of 11 digits"
              maxlength="13"
              @input="formatTelphone"
            ></el-input>
          </el-form-item>
          <!-- 国际中文版 -->
          <el-form-item
            v-if="CheckCN()"
            label="手机号"
            :label-width="formLabelWidth"
            prop="consigneePhone"
          >
            <el-input
              v-model="cardForm_ticket.consigneePhone"
              autocomplete="off"
              placeholder="请输入11位手机号码"
              maxlength="13"
              @input="formatTelphone"
            ></el-input>
          </el-form-item>

          <!-- 国际 英文版 -->
          <el-form-item
            v-if="!CheckCN()"
            label="Identifying code"
            
            prop="verificationCode"
            class="verification_item el-form-item-two"
            style="margin-bottom:25px;"
          
          >
            <el-input
              v-model="cardForm_ticket.verificationCode"
              autocomplete="off"
              placeholder="Pls input identifying code"
            ></el-input>

            <span
              class="code_verification"
              :class="{ count_dowm_run: countDown_flag }"
              @click="getCountDown"
              >{{ countDown_text }}</span
            >
          </el-form-item>
          <!-- 国际 中文版 -->
          <el-form-item
            v-if="CheckCN()"
            label="验证码"
            :label-width="formLabelWidth"
            prop="verificationCode"
            class="verification_item"
            style="margin-bottom:25px;"
          >
            <el-input
              v-model="cardForm_ticket.verificationCode"
              autocomplete="off"
              placeholder="请输入验证码"
            ></el-input>

            <span
              class="code_verification"
              :class="{ count_dowm_run: countDown_flag }"
              @click="getCountDown"
              >{{ countDown_text }}</span
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from "@/utils";
export default {
  name: "TicketUser",
  data() {
    var user_checked = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(TLang('姓名不能为空','address')));
      } else {
        callback();
      }
    };
    var tel_checked = (rule, value, callback) => {
      if (!value && parseInt(value) != 0) {
        callback(new Error(TLang('手机号不能为空','address')));
      } else {
        let currvalue = value.replace(/\D/g, ""); //去除空格
        if (!/^1\d{10}$/.test(currvalue)) {
          callback(new Error(TLang('请输入正确的手机号码','address')));
        }
        callback();
      }
    };
    var card_checked = (rule, value, callback) => {
      if (!value && parseInt(value) != 0) {
        callback(new Error(TLang('身份证号码不能为空','address')));
      } else {
        let currvalue = value.replace(/\s*/g, ""); //去除空格
        if (!/^\d{17}[0-9a-zA-Z]{1}$/.test(currvalue)) {
          callback(new Error(TLang('请输入正确的身份证号码','address')));
        }
        callback();
      }
    };
    var veification_checked = (rule, value, callback) => {
      if (!value && parseInt(value) != 0) {
        callback(new Error(TLang('验证码不能为空','address')));
      } else {
        // if (!/^1\d{10}$/.test(value)) {
        //   callback(new Error("请输入正确的验证码"));
        // }
        callback();
      }
    };
    return {
      initTimer: null, //定时器
      // eslint-disable-next-line no-undef
      countDown_text: TLang("获取验证码", "address"),
      countDown_flag: false, //倒计时是否结束
      formLabelWidth: "56px",
      cardForm_ticket: this.cardFormData,
      watchTel: "",
      watchTel_flag: "",
      cardRules: {
        consigneeName: [{ validator: user_checked, trigger: "blur" }],
        consigneePhone: [{ validator: tel_checked, trigger: "blur" }],
        ownerIdCardNo: [{ validator: card_checked, trigger: "blur" }],
        verificationCode: [{ validator: veification_checked, trigger: "blur" }]
      },
      real_type: this.real_name_type,
      CookiesOne: getCookie('df_lang'),
    };
  },
  props: ["cardFormData", "real_name_type"],
  watch: {
    cardFormData: {
      handler: function(newVal) {
        this.cardForm_ticket = newVal;
      },
      deep: true,
      immediate: true
    },
    real_name_type(val) {
      this.real_type = val;
    },
    watchTel(newVal) {
      this.watchTel_flag = newVal;
    }
  },
  components: {},
  beforeCreate() {},
  created() {
    this.$refs["cardRules"] ? this.$refs["cardRules"].resetFields() : "";
  },
  destroyed() {
    clearInterval(this.initTimer);
  },
  computed: {},
  methods: {
    formatCardNo() {
      this.cardForm_ticket.ownerIdCardNo = this.cardForm_ticket.ownerIdCardNo.toUpperCase(); //转字母大写
      this.formatDeepCard();
    },
    formatDeepCard() {
      this.cardForm_ticket.ownerIdCardNo = this.cardForm_ticket.ownerIdCardNo.replace(
        /[^0-9A-z]/g,
        ""
      );
      let valLength = this.cardForm_ticket.ownerIdCardNo.replace(
        /[^0-9A-z]/g,
        ""
      ).length;
      if (valLength > 6 && valLength <= 14) {
        this.cardForm_ticket.ownerIdCardNo =
          this.cardForm_ticket.ownerIdCardNo.slice(0, 6) +
          " " +
          this.cardForm_ticket.ownerIdCardNo.slice(6);
      } else if (valLength > 14) {
        this.cardForm_ticket.ownerIdCardNo =
          this.cardForm_ticket.ownerIdCardNo.slice(0, 6) +
          " " +
          this.cardForm_ticket.ownerIdCardNo.slice(6, 14) +
          " " +
          this.cardForm_ticket.ownerIdCardNo.slice(14);
      } else {
        this.cardForm_ticket.ownerIdCardNo = this.cardForm_ticket.ownerIdCardNo;
      }
    },
    formatTelphone() {
      this.watchTel = this.cardForm_ticket.consigneePhone.replace(/\D/g, "");
      let telLength = this.watchTel.length;
      //增加
      if (this.watchTel.length > this.watchTel_flag.length) {
        if (telLength == 4 || telLength == 8) {
          this.cardForm_ticket.consigneePhone =
            this.cardForm_ticket.consigneePhone.slice(
              0,
              this.cardForm_ticket.consigneePhone.length - 1
            ) +
            " " +
            this.cardForm_ticket.consigneePhone.slice(-1);
        }
      } else {
        //删除
        if (this.watchTel_flag.length == 4 || this.watchTel_flag.length == 8) {
          this.cardForm_ticket.consigneePhone = this.cardForm_ticket.consigneePhone.trim();
        }
      }
    },
    //校验表单信息
    getCheckForm() {
      let check_flag = false;
      this.$refs["cardForm_ticket"].validate(valid => {
        if (valid) {
          check_flag = true;
        } else {
          check_flag = false;
        }
        this.$emit("formData", {
          check_flag: check_flag,
          name: this.cardForm_ticket.consigneeName,
          phone: this.cardForm_ticket.consigneePhone.replace(/\D/g, ""),
          code: this.cardForm_ticket.verificationCode,
          card: this.cardForm_ticket.ownerIdCardNo.replace(/\s*/g, "")
        });
      });
    },
    //发送验证码
    getSendCode(val) {
      let sendSource = {
        consigneePhone: val
      };
      this.apis.showOrder.getSendCode(sendSource);
    },
    //验证码倒计时
    getCountDown() {
      let telPhone = this.cardForm_ticket.consigneePhone.replace(/\D/g, "");
      if (!/^1\d{10}$/.test(telPhone)) {
        this.publicMethod.getThrowInfo(
          // eslint-disable-next-line no-undef
          TLang("请填写正确的手机号", "address", false, false, null),
          "error"
        );
        // 
      } else {
        if (!this.countDown_flag) {
          this.countDown_text = 60 + "s";
          let countDownTime = 60;
          this.countDown_flag = true;
          clearInterval(this.initTimer);
          this.initTimer = setInterval(() => {
            countDownTime--;
            this.countDown_text = countDownTime + "s";
            if (countDownTime == 0) {
              this.countDown_text = TLang('重新获取','address',false,false,null);
              this.countDown_flag = false;
              clearInterval(this.initTimer);
            }
          }, 1000);
          //发送验证码
          this.getSendCode(telPhone);
        } else {
          return false;
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .user_ticket_info input::-webkit-input-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
/deep/ .user_ticket_info input:-moz-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
/deep/ .user_ticket_info input::-moz-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
/deep/ .user_ticket_info input:-ms-input-placeholder {
  font-size: 14px;
  color: rgba(204, 204, 204, 1);
}
.ticket_info_user_title {
  display: flex;
  justify-content: space-between;
  .way_title_left {
    display: flex;
    align-items: center;
  }
}
.ticket_icon {
  line-height: 21px;
}
.ticket_icon img {
  width: 20px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}
.ticket_icon span {
  .drama_font_style(inherit, 500, 16px, 21px);
  display: inline-block;
  margin-left: 15px;
  color: rgba(17, 17, 17, 1);
  height: 21px;
}
.ticket_icon i {
  .drama_font_style(normal, 500, 12px, 16px);
  margin-left: 4px;
  color: rgba(102, 102, 102, 1);
}
.ticket_info_user_table {
  margin: 18px 0 8px 32px;
  /deep/ .user_ticket_info .el-form-item {
    margin: 24px 0 0 4px;
  }
  /deep/ .user_ticket_info .el-form-item__label {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }
  /deep/ .user_ticket_info .el-form-item__content {
    width: 320px;
  }
  /deep/ .user_ticket_info .el-input__inner {
    width: 320px;
    height: 32px;
    border-radius: 0;
    color: #000000;
    line-height: 32px;
  }

  /deep/ .user_ticket_info .el-input__inner:focus {
    border-color: #e5e5e5;
  }
  .user_ticket_info {
    .code_verification {
      color: rgba(17, 17, 17, 1);
    }
  }
}
/deep/ .verification_item {
  position: relative;
  .code_verification {
    .drama_wrap_attr(84px, 34px, 34px, 12px, rgba(61, 150, 226, 1), inherit);
    text-align: center;
    padding-left: 12px;
    padding-right: 12px;
    cursor: pointer;
    position: absolute;
    right: 0px;
    top: 0px;
    font-family: MicrosoftYaHei;
  }
  .count_dowm_run {
    color: rgba(153, 153, 153, 1) !important;
  }
  .code_verification:before {
    display: none; //走查隐藏
    content: "";
    position: absolute;
    left: 0px;
    top: 10px;
    height: 14px;
    width: 1px;
    background: rgba(240, 240, 240, 1);
  }
}
.el-form-item-One{
     display: flex;
     .el-input:first-child{
     margin-left: 30px;
  }
}
.el-form-item-two{
     display: flex;
     .el-input:first-child{
     margin-left: 20px;
     &::before{
       margin-left: 20px!important;
     }
  }
}
.el-form-item-three{
    display: flex;
      .el-input:first-child{
      margin-left: 9px;
    }
  
}
/deep/ .el-form-item-three .el-form-item__error{
      margin-left: 10px!important;
}
/deep/ .el-form-item-two .el-form-item__error{
      margin-left: 20px!important;
}
/deep/ .el-form-item-One .el-form-item__error{
      margin-left: 30px!important;
}
</style>
